module.exports = __webpack_public_path__ + "static/CircularStd-Black-7f42d8488652eb250af2f484d377dbee.otf";